/* Contraseñas entre 8 a 16 caracteres con al menos una mayúscula, una minúscula, numeros y caracteres especiales */
export const PASS_PATERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&#.$($)$-$_])[A-Za-z\d$@$!%*?&#.$($)$-$_]{8,16}$/;

/* Código CMP que permite valores numéricos de seis dígitos */
export const CMP_CODE = /^[0-9]{6}$/;

// Carnet de Identidad
export const CI_CU =
  /^\d{2}([0]?[0-9]{1}|[1]?[0-2]{1})([0-2]{1}?[0-9]{1}|[3]?[0-1]{1})(\d{5})$/;

/* =========== NUMEROS DE TELEFONOS ================*/
export const CUBA_MOVIL_CODE = /^(\+53|53)?[5][0-9]{7}$/;
export const CUBA_PHONE_CODE = /^(\+53|53)?[0-9]{8}$/;

/* =============== NUMEROS =================*/

/* Numero decimal separados por punto */
export const DECIMAL_NUMBER = /(^\d*\.?\d*[1-9]+\d*$)|(^[1-9]+\d*\.\d*$)/;

/* Numero entero positivo mayor que cero */
export const POSITIVE_NUMBER = /^[1-9]+[0-9]*$/;

export const NUMBER_ONLY = /^[0-9]+$/;

/* =============== CADENAS =================*/
export const ALPHA_ONLY = /^[a-zA-ZáéíóúñÁÉÍÓÚÑ ]+$/;
export const ALPHA_WHITOUT_SPACE = /^\S*$/;

/* ================ HORA ====================== */

export const TIME_12H = /(((0[1-9])|(1[0-2])):([0-5])([0-9])\s(A|P)M)/;

export const FACEBOOK_LINK =
  /((http|https):\/\/|)(www\.|)facebook\.com\/[a-zA-Z0-9.]{1,}/;

export const TWITTER_LINK =
  /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/;

export const INSTAGRAM_LINK =
  /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/;

export const EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const URL_REGEX = /^https?:\/\/[\w-]+(\.[\w-]+)+[/#?]?.*$/;

export const IPV4 =
  /^(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/;
